import { ConfigProvider } from 'antd';
import { AntdProviderProps } from './AntdProvider.types';
import { useAntdConfig } from './useAntdConfig';

export function AntdProvider({ children }: AntdProviderProps) {
  const antdConfig = useAntdConfig();

  return <ConfigProvider theme={antdConfig}>{children}</ConfigProvider>;
}
